var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Heading } from '../heading';
import { useCard } from './card-context';
var sizeMap = {
    large: 'xlarge',
    medium: 'large',
};
function Header(_a) {
    var _b = _a.as, as = _b === void 0 ? 'h3' : _b, children = _a.children, restProps = __rest(_a, ["as", "children"]);
    var size = useCard().size;
    return (_jsx(Heading, __assign({ size: sizeMap[size] }, __assign({ as: as }, restProps), { children: children })));
}
export default Header;
